import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { leaguePracticeStore } from 'state/league/leaguePractice'
import AddPracticeForm from './ModalContent/AddPracticeForm'

const AddPracticeModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { addPracticeModal, setAddPracticeModal, setSelectedPractice } =
    leaguePracticeStore(store => ({
      addPracticeModal: store.addPracticeModal,
      setAddPracticeModal: store.setAddPracticeModal,
      setSelectedPractice: store.setSelectedPractice,
    }))

  const closeModal = () => {
    setSelectedPractice(null)
    setAddPracticeModal(false)
  }

  return (
    <CustomModal
      openModal={addPracticeModal}
      isCloseModalCustom
      closeModal={closeModal}
      title="Add practice game"
      footer={
        <CustomModalFooter
          multibutton={false}
          btnAlignment="justify-end"
          btnText="Save game"
          closeModal={closeModal}
          onSubmit={handleSubmit}
        />
      }
    >
      <AddPracticeForm form={form} />
    </CustomModal>
  )
}

export default AddPracticeModal
